import DemographicsSettings from 'components/pages/DemographicsSettings/DemographicsSettings';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('account');
export default buildPage(DemographicsSettings, {
  requiresAuthentication: true,
  metaData: {
    title: 'Account Settings',
    description: 'Manage your account settings.',
  },
});
